export class RegisterUser {
  public username!: string;
  public email!: string;
  public password!: string;

  constructor(values?: RegisterUser) {
    Object.assign(this, values);
  }
}
